import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image"

export default ({ childImageSharp, extension, publicURL, alt, ...props }) => {
    if (!childImageSharp && extension === '.svg') {
        return <img src={publicURL} alt={alt} {...props} />
    }
    return <GatsbyImage image={childImageSharp.gatsbyImageData} alt={alt} {...props} />;
}
